import { render, staticRenderFns } from "./BlockType120.vue?vue&type=template&id=e0870a94"
import script from "./BlockType120.vue?vue&type=script&lang=ts"
export * from "./BlockType120.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports